import React from "react";
import MuiCell from "@material-ui/core/TableCell";
import withStyles from "../../../styles/withStyles";

function Cell(props) {
  return <MuiCell {...props} />;
}

let styles = theme => ({
  root: {
    fontSize: "14px"
  },
  head: {
    backgroundColor: theme.palette.secondary.light,
    fontSize: "14px",
    fontWeight: "600",
    textTransform: "uppercase"
  },
  footer: {
    fontSize: "14px",
    fontWeight: "600",
    textTransform: "uppercase",
    textAlign: "right",
    borderBottom: "none"
  },
  paddingCheckbox: {
    paddingLeft: "8px"
  }
});

export default withStyles(styles)(Cell);
